import { render, staticRenderFns } from "./RagioneriaQuietanziantiView.vue?vue&type=template&id=3856afd9&"
import script from "./RagioneriaQuietanziantiView.vue?vue&type=script&lang=ts&"
export * from "./RagioneriaQuietanziantiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports